<h1 mat-dialog-title>Job Success</h1>
<div mat-dialog-content>
  <p>The job has been submitted. Do you want to go to the alert page?</p>

</div>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial (click)="onClick()">Ok</button>
  </mat-dialog-actions>